import useFeatureSetting from './../../hooks/useFeatureSetting';

export default ({ flag, children }) => useFeatureSetting(flag) && children ? children : null
